// ============================================================
// WithheldAmount.tsx — (Batch 4) "See colleagues' billing".
// Rendered wherever an Activity entry's £ was withheld by the server
// (amountPence === null): a subtle lock + "—", the same quiet show-but-lock
// treatment as a Restricted case/file — never asterisks, never a fake £0.
// Time / units are shown as normal next to it.
// ============================================================
import React from 'react'

export const WITHHELD_AMOUNT_TIP = "A colleague's billing — you don't have access to see its £ value"

const WithheldAmount: React.FC<{ className?: string; size?: number }> = ({ className = '', size = 12 }) => (
  <span className={`inline-flex items-center gap-1 text-casevo-text-soft font-normal ${className}`} title={WITHHELD_AMOUNT_TIP} aria-label={WITHHELD_AMOUNT_TIP}>
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </svg>
    <span aria-hidden="true">—</span>
  </span>
)

export default WithheldAmount
